export default __webpack_public_path__ + "static/media/jezryl_dark.f4908abb.svg";